import React from 'react';
import CompletionBar from '../CompletionBar';
import BarreEtape from '../BarreEtape';

const Step2_PackType = ({ data, updateData, nextStep, prevStep }) => {
  const packTypes = [
    {
      value: 'murs_fonds',
      label: 'Murs + Fonds',
      icon: 'bi-building-fill',
      description: 'Vente des murs (local commercial) + Cession du fonds de commerce',
      primary: true
    },
    {
      value: 'fonds_licence',
      label: 'Fonds + Licence',
      icon: 'bi-cup-fill',
      description: 'Cession du fonds + Licence de débit de boissons',
      primary: false
    },
    {
      value: 'dab_local',
      label: 'Droit au bail + Local',
      icon: 'bi-file-earmark-text',
      description: 'Cession droit au bail + Référence du local support',
      primary: false
    }
  ];

  const handlePackSelection = (isPack) => {
    updateData({ is_pack: isPack });
    if (!isPack) {
      updateData({ pack_type: '', bundle_mode: 'ensemble' });
    }
  };

  const handlePackTypeSelection = (type) => {
    updateData({ pack_type: type });
  };

  return (
    <div className="space-y-6">
      {/* Barre de complétion */}
      <CompletionBar data={data} currentStep={2} />
      
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Ce bien fait-il partie d'un pack ?
        </h2>
        <p className="text-gray-600">
          Un pack regroupe plusieurs biens juridiquement distincts mais commercialement liés.
        </p>
      </div>

      {/* Choix Oui/Non */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <button
          onClick={() => handlePackSelection(false)}
          className={`p-6 border-2 rounded-lg transition-all ${
            data.is_pack === false
              ? 'border-blue-600 bg-blue-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <i className="bi bi-box text-4xl text-blue-600 mb-3 block"></i>
          <div className="font-semibold text-lg mb-1">Bien simple</div>
          <div className="text-sm text-gray-600">Un seul bien, une seule opération juridique</div>
        </button>

        <button
          onClick={() => handlePackSelection(true)}
          className={`p-6 border-2 rounded-lg transition-all ${
            data.is_pack === true
              ? 'border-blue-600 bg-blue-50'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <i className="bi bi-boxes text-4xl text-blue-600 mb-3 block"></i>
          <div className="font-semibold text-lg mb-1">Pack / Dossier combiné</div>
          <div className="text-sm text-gray-600">Plusieurs biens liés commercialement</div>
        </button>
      </div>

      {/* Sélection du type de pack */}
      {data.is_pack && (
        <div className="space-y-4 animate-fade-in">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start gap-2">
              <i className="bi bi-info-circle text-blue-600"></i>
              <div className="text-sm text-blue-800">
                <p className="font-semibold mb-1">Sélectionnez le type de pack</p>
                <p>Vous allez créer 2 biens distincts qui seront automatiquement liés dans un dossier commercial commun.</p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            {packTypes.map((pack) => (
              <button
                key={pack.value}
                onClick={() => handlePackTypeSelection(pack.value)}
                className={`w-full p-4 border-2 rounded-lg text-left transition-all ${
                  data.pack_type === pack.value
                    ? 'border-blue-600 bg-blue-50'
                    : 'border-gray-200 hover:border-gray-300'
                } ${pack.primary ? 'ring-2 ring-orange-400 ring-offset-2' : ''}`}
              >
                <div className="flex items-start gap-4">
                  <i className={`bi ${pack.icon} text-3xl text-blue-600`}></i>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-lg">{pack.label}</span>
                      {pack.primary && (
                        <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full font-semibold inline-flex items-center gap-1">
                          <i className="bi bi-star-fill text-[10px]"></i>
                          PRIORITAIRE
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mt-1">{pack.description}</p>
                  </div>
                  {data.pack_type === pack.value && (
                    <i className="bi bi-check-circle-fill text-blue-600 text-xl"></i>
                  )}
                </div>
              </button>
            ))}
          </div>

          {/* Mode de vente */}
          {data.pack_type && (
            <div className="bg-gray-50 rounded-lg p-4">
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Mode de commercialisation
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <button
                  onClick={() => updateData({ bundle_mode: 'ensemble' })}
                  className={`p-3 border-2 rounded-lg text-sm transition-all ${
                    data.bundle_mode === 'ensemble'
                      ? 'border-blue-600 bg-blue-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <div className="font-semibold mb-1">En bloc</div>
                  <div className="text-xs text-gray-600">Les 2 biens vendus ensemble uniquement</div>
                </button>
                <button
                  onClick={() => updateData({ bundle_mode: 'separable' })}
                  className={`p-3 border-2 rounded-lg text-sm transition-all ${
                    data.bundle_mode === 'separable'
                      ? 'border-blue-600 bg-blue-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <div className="font-semibold mb-1">Séparable</div>
                  <div className="text-xs text-gray-600">Possibilité de vendre séparément</div>
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Navigation */}
      <BarreEtape classeOrdinateur="md:pt-6 md:border-t">
        <button
          onClick={prevStep}
          className="h-11 md:h-auto px-4 md:px-6 md:py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold rounded-lg transition-colors flex items-center gap-2"
        >
          <i className="bi bi-arrow-left"></i>
          Retour
        </button>
        <button
          onClick={nextStep}
          className="h-12 md:h-auto px-6 md:py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors flex items-center gap-2"
        >
          Suivant
          <i className="bi bi-arrow-right"></i>
        </button>
      </BarreEtape>
    </div>
  );
};

export default Step2_PackType;
